// export const API = "http://localhost:8081/api/v1";
//export const DOMAIN = https://idadev-api.ignithocloud.com
export const API = "https://idadev-api.ignithocloud.com/api/v1";
export const AI_API = "https://idadev-api.ignithocloud.com/ai";
export const commonUrl = 'https://idadev.ignithocloud.com';
